import React from 'react';
import LoginPage from './LoginPage';
import SignUpPage from './SignUpPage';
import './App.css';
import HomePage from './pages/HomePage';
import MonitorPage from './pages/MonitorPage';
import Dashboard from './pages/Dashboard';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ReportPage from './pages/ReportPage';
import HistoryPage from './pages/HistoryPage';
import VideoMonitorPage from './pages/VideoMonitorPage';
import DemoVideoPage from './pages/DemoVideoPage';
import DemoCamPage from './pages/DemoCamPage';
import RecordedDemoPage from './pages/RecordedDemoPage';
import ProtectedRoute from './components/ProtectedRoute';
import WaitlistPage from './pages/WaitlistPage';
import AdminPage from './pages/AdminPage';

const App: React.FC = () => {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <div className="App">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/waitlist" element={<WaitlistPage />} />
          <Route path="/admin" element={<ProtectedRoute requiredRole="admin"><AdminPage /></ProtectedRoute>} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/monitor"
            element={
              <ProtectedRoute>
                <DemoCamPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/monitor-download"
            element={
              <ProtectedRoute>
                <MonitorPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/train"
            element={
              <ProtectedRoute requiredRole="admin">
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/report"
            element={
              <ProtectedRoute>
                <ReportPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/history"
            element={
              <ProtectedRoute>
                <HistoryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/demo"
            element={
              <ProtectedRoute requiredRole="admin">
                <VideoMonitorPage />
              </ProtectedRoute>
            }
          />
          <Route path="/demo-video" element={<DemoVideoPage />} />
          <Route path="/demo-cam" element={<DemoCamPage />} />
          <Route path="/demo-replay" element={<RecordedDemoPage />} />
          <Route path="/demo-replay-old" element={<RecordedDemoPage showSparklines={false} />} />
          <Route path="/demo-replay/:demoId" element={<RecordedDemoPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
